exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "a.Tag-default-2FU36{display:inline-block;margin-right:20px;font-size:20px;font-weight:400;text-decoration:none;text-transform:lowercase;color:#b0bec5}a.Tag-default-2FU36:hover{text-decoration:none;color:#546d79}a.Tag-default-2FU36 i{margin:0 10px 0 0}a.Tag-sm-35LrB{font-size:16px;color:#8a959a}a.Tag-right-3Pb_j i{margin:0 0 0 10px}", ""]);

// exports
exports.locals = {
	"default": "Tag-default-2FU36",
	"sm": "Tag-sm-35LrB",
	"right": "Tag-right-3Pb_j"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/core/components/Tag.less
// module id = 1661
// module chunks = 0